export const Fonts = {
    JALDI: 'JALDI',
    INTER: 'INTER',
}